import { useCallback } from "react";
import type { ApiResponse } from "@entrilia/shared/api/types.ts";
import type { ExportResponse } from "../../../../../api/types/svTypes.ts";
import useExport from "./useExport.ts";

export const useDrillDownExport = <T>(
  request: (body: T) => Promise<ApiResponse<ExportResponse>>
): {
  exporting: boolean;
  requestExport: (body: T) => Promise<void>;
} => {
  const { exporting, requestExport } = useExport(20);
  const exportDrillDown = useCallback((body: T) => requestExport(() => request(body)), [request, requestExport]);
  return { exporting, requestExport: exportDrillDown };
};
